import { ExportUrlResponse } from "utils/fetch-export-url";

export const mockExportUrlResponse: ExportUrlResponse = {
  message: "Community request data exported successfully",
  exportUrl:
    "https://ring-community-exports-beta-523240392733.s3.us-east-1.amazonaws.com/exports/community-requests-export-mock.csv",
  expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
  exportedAt: new Date().toISOString(),
  recordCount: 79
};
